// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"f0d99cc9","559":"052735be","772":"98b6a02c"}[chunkId] + ".chunk.js";
};